import React from 'react'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import { useRouter } from 'next/router'

import Text from 'components/Atoms/Text'
import { AppButtons } from 'components/Molecules/DownloadApp'
import { useClientResponsive } from 'helpers/hooks'
import { useTranslation } from 'i18n-web/i18next'

import PhoneNumberForm from '../PhoneNumberForm'

const Component = styled.div`
  position: relative;
  padding: 30px 0;
  background: url('/static/images/how-it-works/download-citifyd/bg.jpg') center
    center no-repeat;
  background-size: cover;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    padding: 80px 0;
  }
`

const Bar = styled.div`
  margin-bottom: 10px;
  width: 100%;
  height: 30px;
  background-color: ${props => props.theme.palette.primary};
  z-index: 10;
`

const Title = styled(Text)`
  font-size: ${props => props.theme.font.size.mobile.h4};
  font-weight: 700;
  line-height: 1.31;
  letter-spacing: -0.2px;
  color: ${props => props.theme.palette.white};

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}rem) {
    font-size: ${props => props.theme.font.size.desktop.h3};
  }
`

const DownloadCitifyd = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const { isMobile } = useClientResponsive()

  return (
    <Component>
      <Grid>
        <Row>
          <Col xs={12} sm={6} smOffset={6}>
            <Bar />
            <Title as="h2">{t('howItWorks.downloadCitifyd.title')}</Title>
            <PhoneNumberForm isLight token={router?.query?.token} />
            {isMobile && <AppButtons />}
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

export default DownloadCitifyd
